import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import WoltDriveAdvancedForm from "./WoltDriveAdvancedForm";
import WoltDriveBasicForm from "./WoltDriveBasicForm";

interface Props {
	appState: AppState;
	form: UseFormReturn<ApplicationUpdateApi>;
}

const WoltDriveForm = ({ appState, form }: Props) => {
	const [updatedConfig, setUpdatedConfig] = useState<Record<string, any> | undefined>(appState.config);

	const handleUpdateConfig = (field: string, obj?: any) => {
		let newObj;
		if (Array.isArray(obj)) {
			newObj = obj.map((item: Record<string, any>) => {
				return {
					name: item.name,
					id: item.id,
				};
			});
		} else {
			newObj = obj !== undefined ? { ...obj } : obj;
		}

		const copiedConfig = { ...updatedConfig };
		if (field === "notification_terminals") {
			copiedConfig.notification_terminals = newObj;
		}

		setUpdatedConfig(copiedConfig);
	};

	return (
		<>
			<WoltDriveBasicForm form={form} />
			<WoltDriveAdvancedForm
				form={form}
				appState={appState}
				handleUpdateConfig={handleUpdateConfig}
				updatedConfig={updatedConfig}
			/>
		</>
	);
};

export default WoltDriveForm;
